const eventDataTypeMap = {
  simple: "simple",
  numeric: "numeric",
  string: "string",
};

const getEvents = (event) => {
  if (!(typeof event === "object")) {
    return { ga: event, op: null, type: eventDataTypeMap.simple };
  }
  const { ga, op, type } = event;

  return { ga, op, type: type || eventDataTypeMap.simple };
};

export default getEvents;
